var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(-0.484 -0.484)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(-1076.516 -299.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(1077 300)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M10.016,0A10.016,10.016,0,1,1,0,10.016,10.016,10.016,0,0,1,10.016,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cancel-2",
    "data-name": "cancel",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 4.807,
    y2: 6.41,
    transform: "translate(-18.829 14.022)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 4.006,
    y2: 12.82,
    transform: "translate(-14.022 7.612)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 4.807,
    y2: 6.41,
    transform: "translate(-18.829 14.022)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 4.006,
    y2: 12.82,
    transform: "translate(-14.022 7.612)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Page_1",
    "data-name": "Page 1",
    d: "M7.117,0,4.043,3.073.97,0,0,.97,3.073,4.043,0,7.117l.97.97L4.043,5.014,7.117,8.087l.97-.97L5.014,4.043,8.087.97Z",
    transform: "translate(1082.972 305.972)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.5fb608f1c0a37e510ccd11a34f391c53.svg";
export { ForwardRef as ReactComponent };